// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"708":"a1c09265","903":"f26c226a","922":"4993eb00"}[chunkId] + ".chunk.css";
};